import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { EcoFabSpeedDialModule } from '@ecodev/fab-speed-dial';
import { ElAsyncAutocompleteModule } from '@el-async-autocomplete';
import { ElAutocompleteModule } from '@el-autocomplete';
import { ElDataListTableModule } from '@el-data-list-table';
import { MonacoEditorModule } from '@materia-ui/ngx-monaco-editor';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { TranslateModule } from '@ngx-translate/core';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { MaterialModule } from '../../material.module';
import { ConfigurableFieldsModule } from '../configurable-fields/configurable-fields.module';
import { SharedModule } from '../shared/shared.module';

import { BmsCommonDltPopupComponent } from './bms-common-dlt-popup/bms-common-dlt-popup.component';
import { BMSCommonFooterButtonsComponent } from './bms-common-footer-buttons/bms-common-footer-buttons.component';
import { BMSCommonPageMainTitleComponent } from './bms-common-page-main-title/bms-common-page-main-title.component';
import { BMSCommonPopupComponent } from './bms-common-popup/bms-common-popup.component';
import { BMSCommonStepperComponent } from './bms-common-stepper/bms-common-stepper.component';
import { BMSCommonStepperHorizontalComponent } from './bms-common-stepper/horizontal-stepper/bms-common-stepper-horizontal.component';
import { BMSCommonStepperVerticalComponent } from './bms-common-stepper/vertical-stepper/bms-common-stepper-vertical.component';
import { BMSCommonTitleSectionComponent } from './bms-common-title-section/bms-common-title-section.component';
import { BMSCommonPopupFooterSectionComponent } from './bms-popup-common-footer-section/bms-popup-common-footer-section.component';
import { InfoBoxComponent } from './info-box/info-box.component';
import { CommonCustomerShareDocumentPopupComponent } from './popups/common-customer-share-document/common-customer-share-document.component';
import { AdditionalDetailsComponent } from './popups/new-send-request-updated/additional-details/additional-details.component';
import { FomSubmitComponent } from './popups/new-send-request-updated/fom-submit/fom-submit.component';
import { NewSendRequestUpdatedComponent } from './popups/new-send-request-updated/new-send-request-updated.component';
import { SendRequestComponent } from './popups/new-send-request-updated/send-request/send-request.component';
import { ReAssignHandlerComponent } from './popups/re-assign-handler/re-assign-handler.component';
import { ShareDocumentComponent } from './popups/share-document/share-document.component';
import { SingleFieldPopupComponent } from './popups/single-field-popup/single-field-popup.component';
import { UploadDocumentComponent } from './popups/upload-document/upload-document.component';
import { ReportUploaderComponent } from './popups/upload-report/upload-report.component';
import { SearchFiledComponent } from './search-fileds/search-filed.component';
import { EmailPreviewPopupComponent } from './popups/email-preview-popup/email-preview-popup.component';

const components = [
  BMSCommonTitleSectionComponent,
  BMSCommonPopupFooterSectionComponent,
  BMSCommonPopupComponent,
  ReportUploaderComponent,
  UploadDocumentComponent,
  ShareDocumentComponent,
  CommonCustomerShareDocumentPopupComponent,
  ReAssignHandlerComponent,
  SingleFieldPopupComponent,
  BMSCommonStepperHorizontalComponent,
  BMSCommonStepperVerticalComponent,
  BMSCommonStepperComponent,
  BMSCommonFooterButtonsComponent,
  BMSCommonPageMainTitleComponent,
  InfoBoxComponent,
  SearchFiledComponent,
  EmailPreviewPopupComponent,
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ...components,
    SendRequestComponent,
    AdditionalDetailsComponent,
    // DialogHeaderComponent,
    FomSubmitComponent,
    NewSendRequestUpdatedComponent,
    BmsCommonDltPopupComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MaterialModule,
    MonacoEditorModule,
    ElDataListTableModule,
    EcoFabSpeedDialModule,
    NgxIntlTelInputModule,
    KeyboardShortcutsModule.forRoot(),
    ElAutocompleteModule,
    CKEditorModule,
    DragDropModule,
    MtxDatetimepickerModule,
    ConfigurableFieldsModule,
    SharedModule,
    ElAsyncAutocompleteModule,
  ],
  exports: [...components],
  providers: [],
})
export class BMSSharedModule {}
